import * as React from "react";
import type { SVGProps } from "react";
const SvgPrivateGymIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15.763 7.778c-.24 0-.477.09-.657.27l-.97.97a.936.936 0 0 0 0 1.315l2.341 2.34-7.71 7.71-2.31-2.31a.93.93 0 0 0-.657-.27c-.24 0-.478.09-.657.27l-.97.97a.936.936 0 0 0 0 1.315l.915.915-.93.93a.936.936 0 0 0 0 1.314l.738.738-.601.6a1.4 1.4 0 0 0 0 1.973l.08.08a1.4 1.4 0 0 0 1.972 0l.6-.602.738.738c.36.36.955.36 1.315 0l.93-.93.925.926c.36.36.955.36 1.315 0l.97-.97a.936.936 0 0 0 0-1.314l-2.321-2.32 7.71-7.71 2.331 2.329c.358.36.956.36 1.315 0l.968-.968a.936.936 0 0 0 0-1.315l-.935-.937.93-.93a.936.936 0 0 0 0-1.314l-.738-.737.601-.601a1.4 1.4 0 0 0 0-1.972l-.08-.08a1.4 1.4 0 0 0-.986-.405 1.4 1.4 0 0 0-.986.405l-.6.6-.738-.736a.92.92 0 0 0-.657-.269.92.92 0 0 0-.657.269l-.93.93-.946-.947a.93.93 0 0 0-.658-.27m0 .928 6.723 6.722h.001l-.971.97-6.722-6.723zm6.172.012c.118 0 .236.048.329.14l.08.08a.46.46 0 0 1 0 .657l-.601.601-.737-.737.6-.6a.46.46 0 0 1 .33-.14m-2.983.004h.002l3.526 3.526-.93.93-3.526-3.526zm-1.818 4.609.738.737-7.71 7.71-.738-.737zM5.8 18.73l6.682 6.682-.97.97L4.83 19.7zm-.054 3.2 3.526 3.526-.93.93-3.526-3.527zm-.193 2.98.737.738-.6.601a.46.46 0 0 1-.658 0l-.08-.08a.46.46 0 0 1 0-.657z"
    />
    <path
      fill="currentColor"
      d="M13.76 1.175a.55.55 0 0 1 .51.013l12.32 6.72a.559.559 0 0 1-.271 1.052.55.55 0 0 1-.267-.068L13.984 2.308 1.922 8.065a.56.56 0 1 1-.482-1.01z"
    />
  </svg>
);
export default SvgPrivateGymIcon;
